export const GET_LIST = 'app/requests/GET_LIST';
export const SET_ONE = 'app/requests/SET_ONE';
export const DELETE_ONE = 'app/requests/DELETE_ONE';
